
window.textColor='#495057'
window.allSubcategories=[]